import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
export default new VueI18n({
  locale: 'en',
  messages: {

    // pt.js
    // --------------------------------------------------
    // Portuguese Translations (Portugal/Brazil)
    // These translations are used for the Portuguese locale
    // in the application. Each key corresponds to a specific
    // term or phrase used in the UI, and the value is the
    // Portuguese translation of that term or phrase.
    // --------------------------------------------------
    pt: {
      '': '',
      user: 'Usuário',
      pass: 'Senha',
      welcome: 'Bem-vindo',
      trucks: 'Camiões',
      menu: 'Menu',
      lines: 'Linhas',
      leasing: 'Locaçao',
      bi: 'BI',
      import: 'Importar',
      export: 'Exportar',
      trucks_sign_up: 'Camiões se inscrever',
      name: 'Nome',
      plate: 'Placa',
      phone: 'Telefone',
      send_sms: 'Enviar Sms',
      message_sent: 'Mensagem enviada com sucesso',
      mail_sent: 'Email enviado com sucesso',
      msg_to_send: 'Digite a mensagem para enviar',
      bay: 'Baia',
      cancel: 'Cancelar',
      capacity_load: 'Capacidade de carga',
      groupage: 'Grupagem',
      weight: 'Peso',
      own_truck: 'Transporte próprio',
      add_truck: 'Adicionar Camião',
      edit_truck: 'Editar Camião',
      date: 'Data',
      hour: 'Hora',
      client: 'Cliente',
      destination: 'Destino',
      notes: 'Notas',
      street: 'Virtual Truck',
      status: 'Status',
      arrival_date: 'Data de chegada',
      arrival_time: 'Hora de chegada',
      departure_date: 'Data de partida',
      departure_time: 'Hora de partida',
      virtual_truck: 'Virtual Truck',
      road: 'Nº de rua',
      k_notes_trw: 'Notas/ações {0}',
      k_notes: 'Notas Kaleido',
      c_notes_trw: 'Notas/ações cliente',
      c_notes: 'Notas Cliente',
      client_notes: 'Notas cliente',
      reason: 'Razoes',
      expeditions: 'Expediçoes',
      dashboard: 'Dashboard',
      receptions: 'Recepçoes',
      type: 'Tipo',
      ok: 'Ok',
      reset: 'Restabelecer',
      save: 'Salvar',
      add_expedition: 'Adicionar Expediçao',
      add_reception: 'Adicionar Recepçao',
      edit_expedition: 'Editar Expediçao',
      edit_reception: 'Editar Recepçao',
      truck: 'Camião',
      detail: 'Detalhe',
      yesterday: 'Ontem',
      today: 'Hoje',
      tomorrow: 'Amanha',
      clean_filters: 'Limpar filtros',
      custom_date: 'Faixa personalizada',
      from: 'De',
      to: 'Para',
      next: 'Próx',
      prev: 'Ant',
      delivery_note_trw: 'Picking',
      delivery_note: 'Picking',
      packages: 'Bultos',
      dispached: 'Despachado',
      in_preparation: 'Em preparação',
      ready_to_sent: 'Pronto a expedir',
      sent: 'Expedido',
      received: 'Recebida',
      ready: 'Pronta',
      revision: 'Revisão',
      cancelled: 'Cancelado',
      attention_req: 'Requer atençao',
      in_progress: 'Em progresso',
      shipper_delay: 'Atraso Camião',
      preparation_delay: 'Atraso carga',
      package_delay: 'Atraso material',
      origin: 'Origem',
      company: 'Companhia',
      add_client: 'Adicionar cliente',
      edit_client: 'Editar cliente',
      select_companies: 'Selecionar companhias',
      select_company: 'Selecionar',
      selected_company: 'Selecionada',
      deselect_company: 'Desmarcar',
      companies_selected: 'Selecionadas',
      in_time: 'Em tempo',
      forward: 'Frente',
      delay: 'Atrasado',
      loading_date: 'Data carga',
      loading_time: 'Hora carga',
      discharge_date: 'Data descarga',
      discharge_time: 'Hora descarga',
      metric: 'Métrica',
      incidences: 'Incidencias',
      both: 'Ambas',
      expeditions_incidences: 'Incidencias expediçao',
      fill_dates: 'Preencher campos de data',
      historic: 'Histórico',
      check_list: 'Lista de verificação',
      print_label: 'Imprimir etiqueta',
      history: 'Histórico de alterações',
      undefined: '',
      urgent: 'Urgente',
      download: 'Descarga',
      download_chart: 'Descargar Chart',
      download_raw: 'Descargar dados',
      download_raw_chart: 'Descargar Chart dados',
      download_raw_detail: 'Descargar Detail dados',
      change_pass: 'Mudar senha',
      pass_different: 'Novas senhas nao combinam',
      loading_discharge_date: 'Data Carga/Descarga',
      loading_discharge_time: 'Hora de Carga/Descarga',
      origin_destination: 'Origem/Destino',
      value: 'Valor',
      booked_date: 'Data prevista',
      booked_time: 'Hora prevista',
      register_date: 'Hora llegada',
      expedition_date: 'Hora envio',
      id: 'Id',
      actions: 'Açoes',
      delete: 'Excluir',
      new: 'Novo',
      change_company: 'Mudar empresa',
      delete_message: 'Tem certeza de que deseja excluir a linha?',
      delete_message_truck: 'Tem certeza de que deseja excluir o camião?',
      delete_message_doc: 'Tem certeza de que deseja excluir o arquivo?',
      indicators: 'Indicadores',
      alerts: 'Alertas',
      first: 'Primeiro',
      second: 'Segundo',
      third: 'Terceiro',
      fourth: 'Quarto',
      trimester: 'Trimestre',
      fill_mandatory: 'Preencha campos obrigatórios',
      invalid_email: 'Email inválido',
      no_images: 'Não há imagens para enviar',
      no_files: 'Não há documentos para enviar',
      zip_created: 'Ficheiro zip descarregado com sucesso',
      code: 'Picking',
      pallet_notes: 'UD Envío',
      route_plate: 'Rota / Placa',
      info_shipper: 'Transporte',
      shipper: 'Camião',
      issued: 'Expedidos',
      show_issued: 'Mostrar Expedidos',
      not_show_issued: 'Não mostrar Expedidos',
      all: 'Mostrar todos',
      si: 'Sim',
      no: 'Nao',
      hi: 'Olá',
      firstname: 'Nome',
      lastname: 'Sobrenome',
      users: 'Utilizadores',
      add_user: 'Adicionar utilizador',
      username: 'Utilizador',
      email: 'E-mail',
      roles: 'Funçao',
      clients: 'Clientes',
      companies: 'Empresas',
      repeat_pass: 'Repita a senha',
      pass_match: 'As senhas nao coincidem',
      files: 'Arquivos',
      close: 'Fechar',
      drag_files_over: 'Clique aquí para subir arquivos',
      drag_images_over: 'Clique aquí para subir imagens',
      download_images: 'Baixar imagens',
      download_documents: 'Baixar documentos',
      download_all: 'Baixar todo',
      send_images: 'Enviar imagens',
      send_documents: 'Enviar documentos',
      send_all: 'Enviar todo',
      shared_id: 'Id ligado',
      critical_lines: 'Linhas prioritárias',
      add_critical_line: 'Adicionar linhas prioritárias',
      critical_line: 'Linha prioritária',
      init_date: 'Data Inicio',
      init_time: 'Tempo Inicio',
      end_date: 'Data Fin',
      end_time: 'Tempo Fin',
      cause: 'Causa',
      activity: 'Atividade',
      line: 'Linha',
      product: 'Produtos',
      contact: 'Contato',
      observations: 'Observações',
      provider: 'Provedor',
      client_name: 'Cliente',
      next_week: 'Semanal',
      next_month: 'próximo mês',
      from_now: 'Desde Agora',
      load_empty: 'Tem Carga',
      load_type: 'Carga Máxima',
      origin_notes: 'Notas Origem',
      repeat: 'Repetir',
      january: 'Janeiro',
      february: 'Fevereiro',
      march: 'Março',
      april: 'Abril',
      may: 'Maio',
      june: 'Junho',
      july: 'Julho',
      august: 'Agosto',
      september: 'Setembro',
      october: 'Outubro',
      november: 'Novembro',
      december: 'Dezembro',
      frecuency: 'Frequência',
      yearly: 'Anual',
      monthly: 'Mensal',
      weekly: 'Semanal',
      daily: 'Diário',
      by_week_day_in_month: 'Por dia da semana no mês',
      by_date_in_month: 'Por data no mês',
      every: 'Cada',
      month_s: 'Més/Meses',
      week_s: 'Semana/s',
      '1st': '1º',
      '2nd': '2º',
      '3rd': '3º',
      '4th': '4º',
      last: 'Último',
      day_s: 'Día/s',
      never_ends: 'Nunca Termina',
      ends_after: 'Termina despois do',
      ends_on: 'Termina em',
      instance_s: 'Repetições',
      monday: 'Segunda-Feira',
      tuesday: 'Terça-Feira',
      wednesday: 'Quarta-Feira',
      thursday: 'Quinta-Feira',
      friday: 'Sexta-Feira',
      saturday: 'Sábado',
      sunday: 'Domingo',
      hide: 'Ocultar',
      show: 'Mostrar',
      window: 'Janela',
      start_at: 'Começa o',
      could_not_be_created: 'Não foi possível criar as seguintes recepções. As datas estão cheias.',
      lockdowns: 'Bloqueios',
      create: 'Criar',
      new_lockdown: 'Novo Bloqueio',
      change: 'Mudar',
      attachments: 'Arquivos',
      gallery: 'Galeria',
      download_as_zip: 'Baixar como zip',
      send_email: 'Enviar por email',
      upload_files: 'Subir archivos',
      upload_images: 'Subir imagens',
      description: 'Descrição',
      enter_description: 'inserir descrição',
      enter_email: 'Inserir emails',
      comma_separated: '(separados por vírgulas)',
      success: 'sucesso',
      saved: 'Guardado',
      number_packages: 'Number packages',
      packing_list: 'Packing List',
      add_packing: 'Adicionar bulto',
      reference: 'Referencia',
      edit: 'Editar',
      add: 'Adicionar',
      material: 'Material',
      edit_packing: 'Editar Bulto',
      add_material: 'Adicionar material',
      new_material: 'Novo material',
      qr_code: 'código QR',
      print_qr: 'Imprimir QR',
      reception: 'Recepcion',
      expedition: 'Expedicion',
      search: 'Buscar',
      current_documents: 'Documentos',
      modified: '',
      advanced: '',
      info_truck: 'Em breve receberá uma mensagem de texto com as instruções a seguir. Obrigado.',
      loading_dock: 'Cais de carga',
      please_go: 'Por favor, dirija-se à ',
      task_list: 'Listado de Tareas',
      tasklist: 'Listado de Tareas',
      add_task: 'Añadir Tarea',
      table_nodata: 'No hay datos',
      machine: 'Maquina',
      type_hour: 'Tipo Hora',
      add_line: 'Añadir Linea',
      task: 'Tarea',
      tasks: 'Tareas',
      export_excel_extend: 'Exportar Excel Extendido',
      worktime: 'Tipo de Horas',
      dock: 'Dock',
      warehouse: 'Muelle',
      truck_register: 'Register truck successfully',
      slide_1: 'Calcule quanto tempo leva para preparar o carregamento ou descarregamento.',
      slide_2: 'Detecte atrasos e suas causas a tempo.',
      slide_3: 'Avalie seus fornecedores.',
      product_info_title_1: 'Comunique em tempo real',
      product_info_text_1_1: 'Se você deseja saber a todo momento em qual fase está o seu {0} ou {1} de suas mercadorias sem precisar entrar em contato com o seu armazém ou centro logístico, {2} é a ferramenta ideal para você.',
      product_info_text_1_2: 'Comunique-se facilmente com os diferentes atores de sua cadeia logística. Cada um pode acessar a plataforma para {0} correspondente à sua etapa ou simplesmente para acessar as {1}.',
      fill_the_information: 'preencher as informações',
      real_time_information: 'informação em tempo real',
      product_info_text_1_3: '{0} é uma plataforma {1} que permite controlar a preparação de {2} e {3}. Também permite acompanhar o status de cada um deles passo a passo de forma visual e intuitiva.',
      online: 'online',
      product_info_text_1_4: 'Com {0}, você pode {1} que permitirá ter {2} sobre os processos do centro logístico.',
      export_statistics: 'exportar estatísticas',
      total_control: 'controle total',
      product_info_title_2: 'Adeus aos atrasos',
      product_info_text_2_1: 'Com seu {0}, {1} envia automaticamente um {2} ao transportador notificando que a carga está pronta para ser carregada e também pode comunicar qualquer informação relevante ou incidentes por meio deste canal.',
      alert_system: 'sistema de alerta',
      sms: 'SMS',
      product_info_title_3: 'Controle seus imprevistos',
      product_info_text_3_1: 'Graças ao {0}, você pode controlar as {1} de suas recepções para que todos estejam atentos à chegada e sejam gerenciados de acordo com seus procedimentos e de acordo com sua {2}.',
      emergencies: 'urgências',
      priority: 'prioridade',
      product_info_title_4: 'Melhore seu processo de tomada de decisão',
      product_info_text_4_1: 'Se você detectou inúmeros atrasos na preparação de suas expedições, {0} ajudará a identificar facilmente as razões para tomar {1}.',
      better_organizational_decisions: 'melhores decisões organizacionais',
      product_info_text_4_2: '{0} é uma ferramenta muito intuitiva e rápida de implementar, portanto, os resultados e as mudanças organizacionais podem ser apreciados rapidamente.',
      product_info_title_5: 'Esqueça o papel',
      product_info_text_5_1: 'Através da plataforma, são geradas etiquetas ou {1} com todas as informações necessárias, evitando a impressão desnecessária de papel.',
      qr_codes: 'códigos QR',
      product_info_title_6: 'Gere relatórios',
      product_info_text_6_1: 'Graças à opção {0} disponível na plataforma, faça o upload de fotos de suas expedições, {1} e {2} para seus clientes com apenas um clique.',
      document_any_incidents: 'documentar quaisquer incidentes',
      generate_reports: 'gerar relatórios',
      more_info_question: 'Solicite sua demonstração online agora ou entre em contato conosco para discutir o seu projeto.',
      more_info: 'Mais Informações',
      client_area: 'Área do Cliente',
      accept_terms_conditions: 'Eu aceito os {0} e a {1}',
      please_accept_terms: 'Por favor, aceite os Termos e Condições e a Política de Privacidade',
      terms_conditions: 'Termos e Condições',
      privacy_policy: 'Política de Privacidade',
      request_information: 'Solicitar Informações',
      products: 'Produtos',
      services: 'Serviços',
      digitalization: 'Digitalização',
      send: 'Enviar',
      back: 'Voltar',
      remarks: 'Observações',
      download_flyer: 'Descargar Flyer',
      bw: 'BorgWarner',
      kl: 'Kaleido',
      n_tags: 'Nº Etiqueta',
      reviews: 'Revisiones',
      pieces_ok: 'Piezas Ok',
      pieces_nok: 'Piezas NOk',
      rework: 'Retrabajadas',
      hours: 'Horas',
      empty: '{field} no puede estar vacio',
      create_task: 'Crear Tarea',
      modified_fields: 'Campos Modificados',
      no_changes: 'Sem alterações',
      old_value: 'Valor Antigo',
      new_value: 'Valor Novo',
      field: 'Campo'
    },

    // en.js
    // --------------------------------------------------
    // English Translations
    // These translations are used for the English locale
    // in the application. Each key corresponds to a specific
    // term or phrase used in the UI, and the value is the
    // English translation of that term or phrase.
    // --------------------------------------------------
    en: {
      '': '',
      user: 'User',
      pass: 'Password',
      welcome: 'Welcome',
      trucks: 'Trucks',
      menu: 'Menu',
      lines: 'Lines',
      leasing: 'Leasing',
      bi: 'BI',
      import: 'Import',
      export: 'Export',
      trucks_sign_up: 'Trucks Sign Up',
      name: 'Name',
      plate: 'Plate',
      phone: 'Phone Number',
      send_sms: 'Send Sms',
      message_sent: 'Message send succesfully',
      mail_sent: 'Email sent successfully',
      msg_to_send: 'Enter the message to send',
      bay: 'Bay',
      cancel: 'Cancel',
      capacity_load: 'Capacity load',
      groupage: 'Groupage',
      weight: 'Weight',
      own_truck: 'Own Truck',
      add_truck: 'Add Truck',
      edit_truck: 'Edit Truck',
      date: 'Date',
      hour: 'Hour',
      client: 'Client',
      destination: 'Destination',
      notes: 'Notes',
      street: 'Virtual Truck',
      status: 'Status',
      arrival_date: 'Arrival date',
      arrival_time: 'Arrival time',
      departure_date: 'Departure Date',
      departure_time: 'Departure Hour',
      virtual_truck: 'Virtual Truck',
      road: 'Road Nº',
      k_notes_trw: '{0} notes/actions',
      k_notes: 'Kaleido Notes',
      c_notes_trw: 'Client notes/action',
      c_notes: 'Client Notes',
      client_notes: 'Client notes',
      reason: 'Reasons',
      expeditions: 'Expeditions',
      dashboard: 'Dashboard',
      receptions: 'Receptions',
      type: 'Type',
      ok: 'Ok',
      reset: 'Reset',
      save: 'Save',
      add_expedition: 'Add Expedition',
      add_reception: 'Add Reception',
      edit_expedition: 'Edit Expedition',
      edit_reception: 'Edit Reception',
      truck: 'Carrier',
      detail: 'Detail',
      yesterday: 'Yesterday',
      today: 'Today',
      tomorrow: 'Tomorrow',
      clean_filters: 'Clean Filters',
      custom_date: 'Custom Range',
      from: 'From',
      to: 'To',
      next: 'Next',
      prev: 'Prev',
      delivery_note_trw: 'Picking',
      delivery_note: 'Delivery Note',
      packages: 'Nº Packages',
      dispached: 'Dispached',
      in_preparation: 'In preparation',
      ready_to_sent: 'Ready to sent',
      sent: 'Sent',
      received: 'Received',
      ready: 'Ready',
      cancelled: 'Cancelled',
      revision: 'Revision',
      attention_req: 'Attention Required',
      in_progress: 'In Progress',
      shipper_delay: 'Carrier Delay',
      preparation_delay: 'Load delay',
      package_delay: 'Package Delay',
      origin: 'Origin',
      company: 'Company',
      add_client: 'Add Client',
      edit_client: 'Edit client',
      select_companies: 'Select companies',
      select_company: 'Select',
      selected_company: 'Selected',
      deselect_company: 'Remove',
      companies_selected: 'Selected',
      in_time: 'In Time',
      forward: 'Forward',
      delay: 'Delayed',
      loading_date: 'Load Date',
      loading_time: 'Load time',
      discharge_date: 'Discharge date',
      discharge_time: 'Discharge time',
      metric: 'Metric',
      incidences: 'Incidences',
      both: 'Both',
      expeditions_incidences: 'Expedition Incidences',
      fill_dates: 'Fill date fields',
      historic: 'History',
      check_list: 'Check List',
      print_label: 'Print Label',
      history: 'History',
      undefined: '',
      urgent: 'Urgent',
      download: 'Download',
      download_chart: 'Download Chart',
      download_raw: 'Download Raw Data',
      download_raw_chart: 'Download Chart Raw Data',
      download_raw_detail: 'Download Detail Raw Data',
      change_pass: 'Change Password',
      pass_different: 'New passwords do not match',
      loading_discharge_date: 'Date Load/Discharge',
      loading_discharge_time: 'Time Load/Discharge',
      origin_destination: 'Origin/Destination',
      value: 'Value',
      expedition_date: 'Hora Envio',
      register_date: 'Arrival Date',
      booked_date: 'Booked Date',
      booked_time: 'Booked Time',
      id: 'Id',
      actions: 'Actions',
      delete: 'Delete',
      new: 'New',
      change_company: 'Change Company',
      delete_message: 'Are you sure you want to DELETE the line?',
      delete_message_truck: 'Are you sure you want to DELETE the truck?',
      delete_message_doc: 'Are you sure you want to DELETE the file?',
      indicators: 'Indicators',
      alerts: 'Alerts',
      first: 'First',
      second: 'Second',
      third: 'Third',
      fourth: 'Fourth',
      trimester: 'Trimester',
      fill_mandatory: 'Fill mandatory fields',
      invalid_email: 'Invalid email',
      no_images: 'No images to send',
      no_files: 'No documents to send',
      zip_created: 'File zip downloaded successfully',
      code: 'Delivery Note',
      pallet_notes: 'Palletization',
      route_plate: 'Route / Plate',
      info_shipper: 'Transport',
      shipper: 'Shipper',
      issued: 'Dispatched',
      show_issued: 'Show Dispatched',
      not_show_issued: 'Not Show Dispatched',
      all: 'Show all',
      si: 'Yes',
      no: 'No',
      hi: 'Hi',
      firstname: 'Firstname',
      lastname: 'Lastname',
      users: 'Users',
      add_user: 'Add user',
      username: 'Username',
      email: 'E-mail',
      roles: 'Roles',
      clients: 'Clients',
      companies: 'Companies',
      repeat_pass: 'Repeat Password',
      pass_match: 'Passwords do not match',
      files: 'Files',
      close: 'Close',
      drag_files_over: 'Click here to upload files',
      drag_images_over: 'Click here to upload images',
      download_images: 'Download Images',
      download_documents: 'Download Documents',
      download_all: 'Download All',
      send_images: 'Send Images',
      send_documents: 'Send Documents',
      send_all: 'Send All',
      shared_id: 'Shared Id',
      critical_lines: 'Priority lines',
      add_critical_line: 'Add priority line',
      critical_line: 'Priority Line',
      init_date: 'Init Date',
      init_time: 'Init Time',
      end_date: 'End Date',
      end_time: 'End Time',
      cause: 'Cause',
      activity: 'Activity',
      line: 'Line',
      product: 'Product',
      contact: 'Contact',
      observations: 'Observations',
      provider: 'Provider',
      client_name: 'Client',
      next_week: 'Next Week',
      next_month: 'Next Month',
      from_now: 'From Now',
      load_empty: 'Has Cargo',
      load_type: 'Full Load',
      origin_notes: 'Origin Notes',
      repeat: 'Repeat',
      frecuency: 'Frequency',
      yearly: 'Yearly',
      monthly: 'Monthly',
      weekly: 'Weekly',
      daily: 'Daily',
      by_week_day_in_month: 'By week day in month',
      by_date_in_month: 'By date in month',
      every: 'Every',
      month_s: 'Month/s',
      '1st': '1st',
      '2nd': '2nd',
      '3rd': '3rd',
      '4th': '4th',
      last: 'Last',
      week_s: 'Week/s',
      day_s: 'Day/s',
      never_ends: 'Never Ends',
      ends_after: 'Ends after',
      ends_on: 'Ends on',
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      instance_s: 'Instance/s',
      december: 'December',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      hide: 'Hide',
      show: 'Show',
      window: 'Window',
      start_at: 'Starts at',
      could_not_be_created: 'The following receptions could not be created. The selected dates are full.',
      lockdowns: 'Lockdowns',
      create: 'Create',
      new_lockdown: 'New Lockdown',
      change: 'Change',
      attachments: 'Attachments',
      gallery: 'Gallery',
      download_as_zip: 'Download as zip',
      send_email: 'Send email',
      upload_files: 'Upload files',
      upload_images: 'Upload images',
      description: 'Description',
      enter_description: 'Enter description',
      enter_email: 'Enter emails',
      comma_separated: '(comma separated)',
      success: 'success',
      saved: 'saved',
      number_packages: 'Number packages',
      packing_list: 'Packing List',
      add_packing: 'Add Package',
      reference: 'Reference',
      edit: 'Edit',
      add: 'Add',
      material: 'Material',
      edit_packing: 'Edit Package',
      add_material: 'Add material',
      new_material: 'New material',
      qr_code: 'code QR',
      print_qr: 'Print QR',
      reception: 'Reception',
      expedition: 'Expedition',
      search: 'Search',
      current_documents: 'Documents',
      delete_doc: '¿Está seguro de querer BORRAR el archivo?',
      modified: '',
      advanced: '',
      search_delivery: 'Search Delivery',
      validate: 'Validate',
      load: 'Load',
      accept: 'Accept',
      info: 'Information',
      warehouse: 'warehouse',
      truck_register: 'Register truck successfully',
      info_truck: 'You will shortly receive a text message with the instructions to follow. Thank you.',
      loading_dock: 'Loading dock',
      please_go: 'Please go to ',
      task_list: 'Tasks List',
      tasklist: 'Tasks List',
      add_task: 'Add Task',
      table_nodata: 'No data',
      machine: 'Machine',
      type_hour: 'Type Hour',
      add_line: 'Add Line',
      export_excel: 'Export Excel',
      task: 'Task',
      tasks: 'Tasks',
      export_excel_extend: 'Export Excel Extend',
      worktime: 'Type hour',
      dock: 'Dock',
      slide_1: 'Calculate how long it takes to prepare the loading or unloading.',
      slide_2: 'Detect delays and their reasons in time.',
      slide_3: 'Evaluate your suppliers.',
      product_info_title_1: 'Communicate in real-time',
      product_info_text_1_1: 'If you want to know at all times in which phase your {0} or {1} of your goods is without having to contact your warehouse or logistics center, {2} is the ideal tool for you.',
      product_info_text_1_2: 'Easily communicate with the different actors in your logistics chain. Each one can access the platform for {0} corresponding to their stage or simply to access the {1}.',
      fill_the_information: 'fill the information',
      real_time_information: 'real-time information',
      product_info_text_1_3: '{0} is an {1} platform that allows you to control the preparation of {2} and {3}. It also allows you to follow the status of each of them step by step visually and intuitively.',
      online: 'online',
      product_info_text_1_4: 'With {0}, you can {1} that will allow you to have {2} over the processes of the logistics center.',
      export_statistics: 'export statistics',
      total_control: 'total control',
      product_info_title_2: 'Goodbye to delays',
      product_info_text_2_1: 'With its {0}, {1} automatically sends a {2} to the carrier notifying them that the cargo is ready to be loaded and can also communicate any relevant information or incidents via this channel.',
      alert_system: 'alert system',
      sms: 'SMS',
      product_info_title_3: 'Manage the unexpected',
      product_info_text_3_1: 'Thanks to {0}, you can control the {1} of your receptions so that everyone is attentive to their arrival and is managed according to your procedures and according to their {2}.',
      emergencies: 'emergencies',
      priority: 'priority',
      product_info_title_4: 'Improve your decision-making process',
      product_info_text_4_1: 'If you have detected numerous delays in the preparation of your expeditions, {0} will help you easily identify the reasons in order to make {1}.',
      better_organizational_decisions: 'better organizational decisions',
      product_info_text_4_2: '{0} is a very intuitive and quick-to-implement tool, so results and organizational changes can be appreciated quickly.',
      product_info_title_5: 'Forget about paper',
      product_info_text_5_1: 'Through the platform, labels or {1} are generated with all the necessary information, avoiding unnecessary paper printing.',
      qr_codes: 'QR codes',
      product_info_title_6: 'Generate reports',
      product_info_text_6_1: 'Thanks to the {0} option available on the platform, upload photos of your expeditions, {1} and {2} for your clients with just one click.',
      document_any_incidents: 'document any incidents',
      generate_reports: 'generate reports',
      more_info_question: 'Request your online demo now or contact us to discuss your project.',
      more_info: 'More Information',
      client_area: 'Client Area',
      accept_terms_conditions: 'I accept the {0} and the {1}',
      please_accept_terms: 'Please, accept the Terms and conditions, and the Privacy Policy',
      terms_conditions: 'Terms & conditions',
      privacy_policy: 'Privacy Policy',
      request_information: 'Request Information',
      products: 'Products',
      services: 'Services',
      digitalization: 'Digitalization',
      send: 'Send',
      back: 'Back',
      remarks: 'Remarks',
      download_flyer: 'Download Flyer',
      bw: 'BorgWarner',
      kl: 'Kaleido',
      n_tags: 'Tag Number',
      reviews: 'Reviews',
      pieces_ok: 'Ok pieces',
      pieces_nok: 'NOk pieces',
      rework: 'Rework',
      hours: 'Hours',
      empty: '{field} must not be blank',
      create_task: 'Create Task',
      modified_fields: 'Modified Fields',
      no_changes: 'No changes',
      old_value: 'Old Value',
      new_value: 'New Value',
      field: 'Field'
    },

    // es.js
    // --------------------------------------------------
    // Spanish Translations
    // These translations are used for the Spanish locale
    // in the application. Each key corresponds to a specific
    // term or phrase used in the UI, and the value is the
    // Spanish translation of that term or phrase.
    // --------------------------------------------------
    es: {
      '': '',
      user: 'Usuario',
      pass: 'Contraseña',
      welcome: 'Bienvenid@',
      trucks: 'Camiones',
      menu: 'Menú',
      lines: 'Lineas',
      leasing: 'Arrendamiento',
      bi: 'AN',
      import: 'Importar',
      export: 'Exportar',
      trucks_sign_up: 'Registrar Camión',
      name: 'Nombre',
      plate: 'Matrícula',
      phone: 'Teléfono',
      send_sms: 'Enviar Sms',
      message_sent: 'Mensaje enviado correctamente',
      mail_sent: 'Email enviado correctamente',
      msg_to_send: 'Introduzca el mensaje a enviar',
      bay: 'Bahía',
      cancel: 'Cancelar',
      capacity_load: 'Capacidad de carga',
      groupage: 'Grupaje',
      weight: 'Peso',
      own_truck: 'Transporte propio',
      add_truck: 'Añadir Camión',
      edit_truck: 'Editar Camión',
      date: 'Fecha',
      hour: 'Hora',
      client: 'Cliente',
      destination: 'Destino',
      notes: 'Notas',
      street: 'Camión virtual',
      status: 'Estado',
      arrival_date: 'Fecha llegada',
      arrival_time: 'Hora llegada',
      departure_date: 'Fecha salida',
      departure_time: 'Hora Salida',
      virtual_truck: 'Virtual Truck',
      road: 'Nº de Calle',
      k_notes_trw: 'Notas/acciones {0}',
      k_notes: 'Notas Kaleido',
      c_notes_trw: 'Notas/acciones cliente',
      c_notes: 'Notas Cliente',
      client_notes: 'Notas cliente',
      reason: 'Motivos',
      expeditions: 'Expediciones',
      dashboard: 'Dashboard',
      receptions: 'Recepciones',
      type: 'Tipo',
      ok: 'Ok',
      reset: 'Reset',
      save: 'Guardar',
      expedition_date: 'Hora Envío',
      add_expedition: 'Añadir Expedición',
      add_reception: 'Añadir Recepción',
      edit_expedition: 'Editar Expedición',
      edit_reception: 'Editar Recepción',
      truck: 'Transporte',
      detail: 'Detalle',
      yesterday: 'Ayer',
      today: 'Hoy',
      tomorrow: 'Mañana',
      clean_filters: 'Limpiar Filtros',
      custom_date: 'Rango Personalizado',
      from: 'Desde',
      to: 'Hasta',
      next: 'Sig',
      prev: 'Ant',
      delivery_note_trw: 'Picking',
      delivery_note: 'Albarán',
      packages: 'Nº Bultos',
      dispached: 'Expedido',
      in_preparation: 'En preparación',
      ready_to_sent: 'Listo para enviar',
      sent: 'Enviado',
      received: 'Recibido',
      ready: 'Finalizado',
      revision: 'Revisión',
      cancelled: 'Cancelado',
      attention_req: 'Necesita Atención',
      in_progress: 'En preparación',
      shipper_delay: 'Retraso Camión',
      preparation_delay: 'Retraso en carga',
      package_delay: 'Falta Material',
      origin: 'Origen',
      company: 'Compañía',
      add_client: 'Añadir Cliente',
      edit_client: 'Editar cliente',
      select_companies: 'Seleccionar compañías',
      select_company: 'Seleccionar',
      selected_company: 'Seleccionada',
      deselect_company: 'Desmarcar',
      companies_selected: 'Seleccionadas',
      in_time: 'En Hora',
      forward: 'Adelantado',
      delay: 'Atrasado',
      loading_date: 'Fecha Carga',
      loading_time: 'Hora carga',
      discharge_date: 'Fecha Descarga',
      discharge_time: 'Hora descarga',
      metric: 'Metrica',
      incidences: 'Incidencias',
      both: 'Ambos',
      expeditions_incidences: 'Incidencia Expedición',
      fill_dates: 'Cubre los campos de fecha',
      historic: 'Histórico',
      check_list: 'Check List',
      print_label: 'Imprimir Etiqueta',
      history: 'Histórico de Cambios',
      undefined: '',
      urgent: 'Urgente',
      download: 'Descargar',
      download_chart: 'Descargar Gráfica',
      download_raw: 'Descargar Datos Bruto',
      download_raw_chart: 'Descargar Datos de Gráfica en Bruto',
      download_raw_detail: 'Descargar Datos Detalle Bruto',
      change_pass: 'Cambiar Contraseña',
      pass_different: 'Las nuevas contraseñas no coinciden',
      loading_discharge_date: 'Fecha de Carga/Descarga',
      loading_discharge_time: 'Hora de Carga/Descarga',
      origin_destination: 'Origen/Destino',
      value: 'Valor',
      register_date: 'Fecha llegada',
      booked_date: 'Fecha prevista',
      booked_time: 'Hora prevista',
      id: 'Id',
      actions: 'Acciones',
      delete: 'Borrar',
      new: 'Nuevo',
      change_company: 'Cambiar Compañía',
      delete_message: '¿Estás seguro de querer BORRAR la linea?',
      delete_message_truck: '¿Estás seguro de querer BORRAR el camión?',
      delete_message_doc: '¿Estás seguro de querer BORRAR el archivo?',
      indicators: 'Indicadores',
      alerts: 'Alertas',
      first: 'Primer',
      second: 'Segundo',
      third: 'Tercer',
      fourth: 'Cuarto',
      trimester: 'Trimestre',
      fill_mandatory: 'Rellene los campos obligatorios',
      invalid_email: 'Email no válido',
      no_images: 'No hay imágenes para enviar',
      no_files: 'No hay documentos para enviar',
      zip_created: 'El archivo zip se ha descargado correctamente',
      code: 'Albarán',
      pallet_notes: 'Palletización',
      route_plate: 'Ruta / Matrícula',
      info_shipper: 'Transporte',
      shipper: 'Camión',
      issued: 'Expedidos',
      show_issued: 'Mostrar Expedidos',
      not_show_issued: 'No mostrar Expedidos',
      all: 'Mostrar todos',
      si: 'Sí',
      no: 'No',
      hi: 'Hola',
      users: 'Usuarios',
      lastname: 'Apellido',
      firstname: 'Nombre',
      add_user: 'Añadir usuario',
      username: 'Nombre de usuario',
      email: 'E-mail',
      roles: 'Roles',
      clients: 'Clients',
      companies: 'Compañias',
      repeat_pass: 'Repetir Contraseña',
      pass_match: 'Las contraseñas no coinciden',
      files: 'Archivos',
      close: 'Cerrar',
      drag_files_over: 'Click aquí para subir archivos',
      drag_images_over: 'Click aquí para subir imágenes',
      download_images: 'Descargar imágenes',
      download_documents: 'Descargar documentos',
      download_all: 'Descargar todo',
      send_images: 'Enviar imágenes',
      send_documents: 'Enviar documentos',
      send_all: 'Enviar todo',
      shared_id: 'Id Vinc.',
      critical_lines: 'Líneas prioritarias ',
      add_critical_line: 'Añadir Línea prioritaria',
      critical_line: 'Línea prioritaria',
      init_date: 'Fecha Inicio',
      init_time: 'Hora Inicio',
      end_date: 'Fecha Fin',
      end_time: 'Hora Fin',
      cause: 'Causa',
      activity: 'Actividad',
      line: 'Linea',
      product: 'Producto',
      contact: 'Contacto',
      observations: 'Observaciones',
      provider: 'Proveedor',
      client_name: 'Cliente',
      next_week: 'Próxima Semana',
      next_month: 'Próximo Mes',
      from_now: 'Desde ahora',
      load_empty: 'Tiene Carga',
      load_type: 'Carga Completa',
      origin_notes: 'Notas Origen',
      repeat: 'Repetir',
      january: 'Enero',
      february: 'Febrero',
      march: 'Marzo',
      april: 'Abril',
      may: 'Mayo',
      june: 'Junio',
      july: 'Julio',
      august: 'Agosto',
      september: 'Septiembre',
      october: 'Octubre',
      november: 'Noviembre',
      december: 'Diciembre',
      frecuency: 'Frecuencia',
      yearly: 'Anual',
      monthly: 'Mensual',
      weekly: 'Semanal',
      daily: 'Diario',
      by_week_day_in_month: 'Por dia de la semana en el mes',
      by_date_in_month: 'Por fecha en el mes',
      every: 'Cada',
      month_s: 'Mes/Meses',
      week_s: 'Semana/s',
      '1st': '1º',
      '2nd': '2º',
      '3rd': '3º',
      '4th': '4º',
      last: 'Último',
      day_s: 'Día/s',
      never_ends: 'Nunca Acaba',
      ends_after: 'Acaba despues de',
      ends_on: 'Acaba el',
      instance_s: 'Repeticiones',
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miercoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
      hide: 'Ocultar',
      show: 'Mostrar',
      start_at: 'Empieza en',
      window: 'Ventana',
      could_not_be_created: 'Las siguientes recepciones no pudieron ser creadas. Las fechas seleccionadas están llenas.',
      lockdowns: 'Bloqueos',
      create: 'Crear',
      new_lockdown: 'Nuevo Bloqueo',
      change: 'Cambiar',
      attachments: 'Archivos',
      gallery: 'Galería',
      download_as_zip: 'Descargar como zip',
      send_email: 'Enviar por email',
      upload_files: 'Subir archivos',
      upload_images: 'Subir imágenes',
      description: 'Descripción',
      enter_description: 'Inserte descripción',
      enter_email: 'Inserte emails',
      comma_separated: '(separados por comas)',
      success: 'éxito',
      saved: 'Guardado',
      number_packages: 'Numero de bultos',
      packing_list: 'Packing List',
      add_packing: 'Añadir bulto',
      reference: 'Referencia',
      edit: 'Editar',
      add: 'Añadir',
      material: 'Material',
      edit_packing: 'Editar Bulto',
      add_material: 'Añadir material',
      new_material: 'Nuevo material',
      qr_code: 'código QR',
      print_qr: 'Print QR',
      reception: 'Recepción',
      expedition: 'Expedición',
      search: 'Buscar',
      current_documents: 'Documentos',
      delete_doc: '¿Está seguro de querer BORRAR el archivo?',
      modified: '',
      advanced: '',
      search_delivery: 'Buscar por albarán',
      validate: 'Validar',
      load: 'Cargar',
      accept: 'Aceptar',
      info: 'Información',
      warehouse: 'Muelle',
      truck_register: 'Camion registrado correctamente',
      info_truck: 'En breve recibirá un sms con las instrucciones a seguir. Gracias.',
      loading_dock: 'Muelle de carga',
      please_go: 'Por favor, diríjase a',
      task_list: 'Listado de Tareas',
      tasklist: 'Listado de Tareas',
      add_task: 'Añadir Tarea',
      table_nodata: 'No data',
      machine: 'Maquina',
      type_hour: 'Tipo Hora',
      add_line: 'Añadir Linea',
      export_excel: 'Exportar Excel',
      task: 'Tarea',
      tasks: 'Tareas',
      export_excel_extend: 'Exportar Excel Extendido',
      worktime: 'Tipo de Horas',
      dock: 'Dock',
      slide_1: 'Calcula cuanto tiempo se tarda en la preparación de la carga o descarga',
      slide_2: 'Detecta a tiempo los retrasos y sus motivos',
      slide_3: 'Evalúa a tus proveedores',
      product_info_title_1: 'Comunícate en tiempo real',
      product_info_text_1_1: 'Si quieres saber en todo momento en que fase se encuentra la {0} o la {1} de tus mercancías sin tener que contactar con tu almacén o centro logístico, {2} es la herramienta ideal para ti.',
      product_info_text_1_2: 'Comunícate fácilmente con los diferentes actores de tu cadena logística. Cada uno podrá acceder a la plataforma para {0} correspondiente a su etapa o bien simplemente para disponer de la {1}.',
      fill_the_information: 'rellenar la información',
      real_time_information: 'información en tiempo real',
      product_info_text_1_3: '{0} es una plataforma {1} que permite el control de la preparación de las {2} y {3}. Además, permite seguir paso a paso el estado de cada una de ella de forma visual e intuitiva.',
      online: 'online',
      product_info_text_1_4: 'Con {0} podrás {1} que te permitirán disponer de un {2} sobre los procesos del centro logístico.',
      export_statistics: 'exportar estadísticas',
      total_control: 'control total',
      product_info_title_2: 'Adiós a los retrasos',
      product_info_text_2_1: 'Con su {0}, {1} envía de forma automática un {2} al transportista avisándole de que la mercancía a cargar está preparada y también pudiendo comunicarle por esta vía cualquier información relevante o incidencia.',
      alert_system: 'sistema de alertas',
      sms: 'SMS',
      product_info_title_3: 'Controla tus imprevistos',
      product_info_text_3_1: 'Gracias a {0} puedes controlar las {1} de tus recepciones para que todo el mundo esté atento a su llegada y se gestione acorde a tus procedimientos y según su {2}.',
      emergencies: 'urgencias',
      priority: 'prioridad',
      product_info_title_4: 'Mejora tu proceso de toma de decisiones',
      product_info_text_4_1: 'Si has detectado numerosos retrasos en la preparación de tus expediciones, {0} te ayudará a identificar con facilidad cuales son los motivos con el fin de tomar las {1}.',
      better_organizational_decisions: 'mejores decisiones organizativas',
      product_info_text_4_2: '{0} es una herramienta muy intuitiva y rápida de implementar por lo que los resultados y los cambios organizativos se pueden apreciar rápidamente.',
      product_info_title_5: 'Olvídate del papel',
      product_info_text_5_1: 'A través de la plataforma se generan etiquetas o {0} con toda la información necesaria, evitando imprimir papeles innecesarios.',
      qr_codes: 'códigos QR',
      product_info_title_6: 'Realiza informes',
      product_info_text_6_1: 'Gracias a la opción de {0} disponible en la plataforma, sube las fotos de tus expediciones, {1} y {2} para tus clientes con un solo clic.',
      document_any_incidents: 'documenta cualquier incidencia',
      generate_reports: 'genera reportes',
      more_info_question: 'Solicita ya tu demo online o contacta con nosotros para estudiar tu proyecto.',
      more_info: 'Más información',
      client_area: 'Area Cliente',
      privacy_policy: 'Política de Privacidad',
      terms_conditions: 'Términos & condiciones',
      accept_terms_conditions: 'Acepto los {0} y la {1}',
      please_accept_terms: 'Por favor, acepta los términos y condiciones y la política de privacidad.',
      request_information: 'Solicita Información',
      products: 'Productos',
      services: 'Servicios',
      digitalization: 'Digitalización',
      send: 'Enviar',
      back: 'Volver',
      remarks: 'Comentarios',
      download_flyer: 'Descargar Flyer',
      bw: 'BorgWarner',
      kl: 'Kaleido',
      n_tags: 'Nº Etiqueta',
      reviews: 'Revisiones',
      pieces_ok: 'Piezas Ok',
      pieces_nok: 'Piezas NOk',
      rework: 'Retrabajadas',
      hours: 'Horas',
      empty: '{field} no puede estar vacío',
      create_task: 'Crear Tarea',
      modified_fields: 'Campos Modificados',
      no_changes: 'Sin cambios',
      old_value: 'Valor Antiguo',
      new_value: 'Valor Nuevo',
      field: 'Campo'
    },

    // mx.js
    // --------------------------------------------------
    // Mexican Spanish Translations
    // These translations are used for the Mexican Spanish locale
    // in the application. Each key corresponds to a specific
    // term or phrase used in the UI, and the value is the
    // Mexican Spanish translation of that term or phrase.
    // --------------------------------------------------
    mx: {
      '': '',
      user: 'Usuario',
      address: 'Dirección',
      pass: 'Contraseña',
      welcome: 'Bienvenid@',
      trucks: 'Camiones',
      menu: 'Menú',
      lines: 'Lineas',
      leasing: 'Arrendamiento',
      bi: 'AN',
      import: 'Importar',
      export: 'Exportar',
      trucks_sign_up: 'Registrar Camión',
      name: 'Nombre',
      plate: 'Matrícula',
      phone: 'Teléfono',
      send_sms: 'Enviar SMS',
      message_sent: 'Mensaje enviado correctamente',
      mail_sent: 'Email enviado correctamente',
      msg_to_send: 'Introduzca el mensaje a enviar',
      bay: 'Bahía',
      cancel: 'Cancelar',
      add_truck: 'Añadir Camión',
      edit_truck: 'Editar Camión',
      date: 'Fecha',
      hour: 'Hora',
      client: 'SKU',
      destination: 'Destino',
      notes: 'Notas',
      street: 'Bahía',
      status: 'Estado',
      arrival_date: 'Fecha Llegada',
      arrival_time: 'Hora llegada',
      departure_date: 'Fecha Salida',
      departure_time: 'Hora Salida',
      virtual_truck: 'Virtual Truck',
      road: 'Nº de Bahía',
      k_notes_trw: 'Notas/acciones {0}',
      k_notes: 'Notas Kaleido',
      c_notes_trw: 'Notas/acciones cliente',
      c_notes: 'Notas Cliente',
      reason: 'Motivos',
      expeditions: 'Expediciones',
      dashboard: 'Dashboard',
      receptions: 'Recepciones',
      issued: 'Expedidos',
      show_issued: 'Mostrar Expedidos',
      not_show_issued: 'No mostrar Expedidos',
      all: 'Mostrar todos',
      type: 'Tipo',
      ok: 'Ok',
      reset: 'Reset',
      save: 'Guardar',
      add_expedition: 'Añadir Expedición',
      add_reception: 'Añadir Recepción',
      edit_expedition: 'Editar Expedición',
      edit_reception: 'Editar Recepción',
      truck: 'Transporte',
      detail: 'Detalle',
      yesterday: 'Ayer',
      today: 'Hoy',
      tomorrow: 'Mañana',
      clean_filters: 'Limpiar Filtros',
      capacity_load: 'Capacidad de carga',
      groupage: 'Grupaje',
      weight: 'Peso',
      own_truck: 'Transporte propio',
      custom_date: 'Rango Personalizado',
      from: 'Desde',
      to: 'Hasta',
      next: 'Sig',
      prev: 'Ant',
      delivery_note_trw: 'Folio',
      delivery_note: 'Folio',
      packages: 'Nº Bultos',
      dispached: 'Expedido',
      ready: 'Finalizado',
      cancelled: 'Cancelado',
      attention_req: 'Necesita Atención',
      in_progress: 'En preparación',
      shipper_delay: 'Retraso Camión',
      preparation_delay: 'Retraso en carga',
      package_delay: 'Falta Material',
      origin: 'Origen',
      company: 'Compañía',
      add_client: 'Añadir SKU',
      edit_client: 'Editar SKU',
      select_companies: 'Seleccionar compañías',
      select_company: 'Seleccionar',
      selected_company: 'Seleccionada',
      deselect_company: 'Desmarcar',
      companies_selected: 'Seleccionadas',
      in_time: 'En Hora',
      forward: 'Adelantado',
      delay: 'Atrasado',
      loading_date: 'Fecha Carga',
      discharge_date: 'Fecha Descarga',
      metric: 'Metrica',
      incidences: 'Incidencias',
      both: 'Ambos',
      expeditions_incidences: 'Incidencia Expedición',
      fill_dates: 'Cubre los campos de fecha',
      historic: 'Histórico',
      check_list: 'Check List',
      print_label: 'Imprimir Etiqueta',
      history: 'Histórico de Cambios',
      undefined: '',
      download: 'Descargar',
      download_chart: 'Descargar Gráfica',
      download_raw: 'Descargar Datos Bruto',
      download_raw_chart: 'Descargar Datos de Gráfica en Bruto',
      download_raw_detail: 'Descargar Datos Detalle Bruto',
      change_pass: 'Cambiar Contraseña',
      pass_different: 'Las nuevas contraseñas no coinciden',
      loading_discharge_date: 'Fecha de Carga/Descarga',
      loading_discharge_time: 'Hora de Carga/Descarga',
      origin_destination: 'Origen/Destino',
      value: 'Valor',
      booked_date: 'Fecha prevista',
      booked_time: 'Hora prevista',
      register_date: 'Fecha llegada',
      expedition_date: 'Hora Envío',
      id: 'Id',
      actions: 'Acciones',
      delete: 'Borrar',
      new: 'Nuevo',
      change_company: 'Cambiar Compañía',
      delete_message: '¿Estás seguro de querer BORRAR la linea?',
      delete_message_truck: '¿Estás seguro de querer BORRAR el camión?',
      indicators: 'Indicadores',
      alerts: 'Alertas',
      first: 'Primer',
      second: 'Segundo',
      third: 'Tercer',
      fourth: 'Cuarto',
      trimester: 'Trimestre',
      fill_mandatory: 'Rellene los campos obligatorios',
      invalid_email: 'Email no válido',
      no_images: 'No hay imágenes para enviar',
      no_files: 'No hay documentos para enviar',
      zip_created: 'El archivo zip se ha descargado correctamente',
      weight_error: 'El peso no puede ser 0',
      attachments: 'Archivos',
      gallery: 'Galería',
      close: 'Cerrar',
      download_as_zip: 'Descargar como zip',
      send_email: 'Enviar por email',
      upload_files: 'Subir archivos',
      upload_images: 'Subir imágenes',
      description: 'Descripción',
      enter_description: 'Inserte descripción',
      enter_email: 'Inserte emails',
      comma_separated: '(separados por comas)',
      success: 'éxito',
      saved: 'Guardado',
      search_delivery: 'Buscar por albarán',
      validate: 'Validar',
      load: 'Cargar',
      search: 'Buscar',
      current_documents: 'Documentos',
      accept: 'Aceptar',
      info: 'Información',
      dock: 'Muelle',
      truck_register: 'Camion registrado correctamente',
      ct_info_title_3: 'Controla tus imprevistos',
      slide_1: 'Calcula cuanto tiempo se tarda en la preparación de la carga o descarga',
      slide_2: 'Detecta a tiempo los retrasos y sus motivos',
      slide_3: 'Evalúa a tus proveedores',
      product_info_title_1: 'Comunícate en tiempo real',
      product_info_text_1_1: 'Si quieres saber en todo momento en que fase se encuentra la {0} o la {1} de tus mercancías sin tener que contactar con tu almacén o centro logístico, {2} es la herramienta ideal para ti.',
      product_info_text_1_2: 'Comunícate fácilmente con los diferentes actores de tu cadena logística. Cada uno podrá acceder a la plataforma para {0} correspondiente a su etapa o bien simplemente para disponer de la {1}.',
      fill_the_information: 'rellenar la información',
      real_time_information: 'información en tiempo real',
      product_info_text_1_3: '{0} es una plataforma {1} que permite el control de la preparación de las {2} y {3}. Además, permite seguir paso a paso el estado de cada una de ella de forma visual e intuitiva.',
      online: 'online',
      product_info_text_1_4: 'Con {0} podrás {1} que te permitirán disponer de un {2} sobre los procesos del centro logístico.',
      export_statistics: 'exportar estadísticas',
      total_control: 'control total',
      product_info_title_2: 'Adiós a los retrasos',
      product_info_text_2_1: 'Con su {0}, {1} envía de forma automática un {2} al transportista avisándole de que la mercancía a cargar está preparada y también pudiendo comunicarle por esta vía cualquier información relevante o incidencia.',
      alert_system: 'sistema de alertas',
      sms: 'SMS',
      product_info_title_3: 'Controla tus imprevistos',
      product_info_text_3_1: 'Gracias a {0} puedes controlar las {1} de tus recepciones para que todo el mundo esté atento a su llegada y se gestione acorde a tus procedimientos y según su {2}.',
      emergencies: 'urgencias',
      priority: 'prioridad',
      product_info_title_4: 'Mejora tu proceso de toma de decisiones',
      product_info_text_4_1: 'Si has detectado numerosos retrasos en la preparación de tus expediciones, {0} te ayudará a identificar con facilidad cuales son los motivos con el fin de tomar las {1}.',
      better_organizational_decisions: 'mejores decisiones organizativas',
      product_info_text_4_2: '{0} es una herramienta muy intuitiva y rápida de implementar por lo que los resultados y los cambios organizativos se pueden apreciar rápidamente.',
      product_info_title_5: 'Olvídate del papel',
      product_info_text_5_1: 'A través de la plataforma se generan etiquetas o {0} con toda la información necesaria, evitando imprimir papeles innecesarios.',
      qr_codes: 'códigos QR',
      product_info_title_6: 'Realiza informes',
      product_info_text_6_1: 'Gracias a la opción de {0} disponible en la plataforma, sube las fotos de tus expediciones, {1} y {2} para tus clientes con un solo clic.',
      document_any_incidents: 'documenta cualquier incidencia',
      generate_reports: 'genera reportes',
      more_info_question: 'Solicita ya tu demo online o contacta con nosotros para estudiar tu proyecto.',
      more_info: 'Más información',
      client_area: 'Area Cliente',
      privacy_policy: 'Política de Privacidad',
      terms_conditions: 'Términos & condiciones',
      accept_terms_conditions: 'Acepto los {0} y la {1}',
      please_accept_terms: 'Por favor, acepta los términos y condiciones y la política de privacidad.',
      request_information: 'Solicita Información',
      products: 'Productos',
      services: 'Servicios',
      digitalization: 'Digitalización',
      contact: 'Contacto',
      reception: 'recepción',
      expedition: 'expedición',
      send: 'Enviar',
      back: 'Volver',
      email: 'E-mail',
      remarks: 'Comentarios',
      download_flyer: 'Descargar Flyer',
      n_tags: 'Nº Etiquetas',
      reviews: 'Revisadas',
      pieces_ok: 'Piezas Ok',
      pieces_nok: 'Piezas NOk',
      rework: 'Retrabajadas',
      hours: 'Horas',
      empty: '{field} no puede estar en blanco',
      create_task: 'Crear Tarea',
      task_list: 'Listado de Tareas',
      add_task: 'Añadir Tarea',
      add_line: 'Añadir Linea',
      task: 'Tarea',
      tasks: 'Tareas',
      export_excel: 'Exportar Excel',
      modified_fields: 'Campos Modificados',
      no_changes: 'Sin cambios',
      old_value: 'Valor Antiguo',
      new_value: 'Valor Nuevo',
      field: 'Campo'
    }
  }
})



// WEBPACK FOOTER //
// ./src/language.js